import { type AxiosInstance } from 'axios';
import { type Middleware } from 'redux';

import { revokeAuth } from '~/actions/user.actions';

const authRevokeMiddleware =
  (clients: AxiosInstance[]): Middleware =>
  (store) => {
    clients.forEach((client) => {
      client.interceptors.response.use(
        (response) => response,
        (error) => {
          if (error?.response?.status === 401) store.dispatch(revokeAuth());

          return Promise.reject(error);
        },
      );
    });

    return (next) => (action) => next(action);
  };

export default authRevokeMiddleware;
